export default __webpack_public_path__ + "static/media/AchievementsHeader.7d7c3ccc.png";